// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__14FbI","title":"FrontImage_title__3Udi2"};